// House of Addams - Global theme scripts

jQuery(function($) {

  /* ============================
     DESKTOP NAV: Superfish menu
     ============================ */
  if ($.fn.supersubs && $.fn.superfish) {
    $('#nav ul').supersubs({
      minWidth: 12,
      maxWidth: 27,
      extraWidth: 1
    }).superfish();
  }

  /* ============================
     HOMEPAGE SLIDER
     ============================ */
  if ($.fn.responsiveSlides && $('#slider').length) {
    $('#slider').responsiveSlides({
      auto: true,
      pager: false,
      nav: true,
      speed: 500,
      timeout: 6000,
      pause: true,
      namespace: 'hoa-rslides'
    });
  }

  /* ============================
     SCROLL TO TOP
     ============================ */
  var $scrollup = $('.scrollup');
  if ($scrollup.length) {
    $(window).on('scroll', function() {
      $(this).scrollTop() > 200 ? $scrollup.fadeIn() : $scrollup.fadeOut();
    });

    $scrollup.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 600);
    });
  }

  /* ============================
     MOBILE MENU
     ============================ */
  var $body = $('body');
  var $toggle = $('.hoa-mobile-menu-toggle');
  var $overlay = $('#hoa-mobile-menu-overlay');
  var $menu = $('#hoa-mobile-menu');

  function openMenu() {
    $body.addClass('hoa-mobile-menu-open');
    $toggle.attr('aria-expanded', 'true');
    $menu.attr('aria-hidden', 'false');
  }

  function closeMenu() {
    $body.removeClass('hoa-mobile-menu-open');
    $toggle.attr('aria-expanded', 'false');
    $menu.attr('aria-hidden', 'true');
  }

  $toggle.on('click', function(e) {
    e.preventDefault();
    $body.hasClass('hoa-mobile-menu-open') ? closeMenu() : openMenu();
  });

  $overlay.on('click', closeMenu);

  $(document).keyup(function(e) {
    if (e.key === "Escape") closeMenu();
  });

  /* ============================
     SUBMENU TOGGLE — FULL ROW CLICK
     ============================ */
  $('.hoa-mobile-menu-item.has-children > a').on('click', function(e) {
    e.preventDefault();

    var $row = $(this);
    var $item = $row.closest('.hoa-mobile-menu-item');
    var $submenu = $item.children('.hoa-mobile-submenu');

    $item.toggleClass('is-open');

    if ($submenu.length) {
      $submenu.slideToggle(200);
    }
  });

});



jQuery(function ($) {
  // Close mobile menu helper (matches your existing behavior)
  function closeHoaMobileMenu() {
    $('body').removeClass('hoa-mobile-menu-open');
    $('.hoa-mobile-menu-toggle').attr('aria-expanded', 'false');
    $('#hoa-mobile-menu').attr('aria-hidden', 'true');
  }

  // When tapping the CONTACT icon inside the mobile menu:
  // 1) close menu
  // 2) allow the modal click handler to fire normally
  $(document).on('click', '#hoa-mobile-menu .js-open-hoa-contact', function () {
    closeHoaMobileMenu();
  });
});


